import { render, staticRenderFns } from "./TeacherFileModal.vue?vue&type=template&id=5fae9e5e&scoped=true"
import script from "./TeacherFileModal.vue?vue&type=script&lang=js"
export * from "./TeacherFileModal.vue?vue&type=script&lang=js"
import style0 from "./TeacherFileModal.vue?vue&type=style&index=0&id=5fae9e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fae9e5e",
  null
  
)

export default component.exports